export function getCookie(name) {
    if(process.env.REACT_APP_ENVIRONMENT === "development"){
      
      return "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS11YXQubWF3YWxvZy5jb20vYWRtaW4vdjIvYXBpL2xvZ2luIiwiaWF0IjoxNzQ4NjY5MjYzLCJleHAiOjE3NDg3NTU2NjMsIm5iZiI6MTc0ODY2OTI2MywianRpIjoiTVB4Qk1vZExoZ0NoT0pldSIsInN1YiI6IjQyMSIsInBydiI6IjlhZDU4NTc3ZmFiNmZiYzE1NTQzNGQzNTkxZWRmMTY0YTE3NzY1YWEiLCJhdXRoaWQiOjQyMSwib3JnaWQiOjEwMCwidXNlcmlkIjo0MjEsImRhdGFiYXNlbmFtZSI6InJhZ3VyciIsIm9yZ19jb2RlIjoicmFndXJyIiwidGltZXpvbmUiOiIgKyBpbnRlcnZhbCAnMDUgaG91cnMgMzAgbWludXRlcyciLCJyb2xlaWQiOjQwMSwicGF5bWVudF9zdGF0dXMiOnRydWUsImF1dGhvcml0aWVzIjpbIlJPTEVfVVNFUiJdfQ.VL7ugVkLFzcTnyXaoKq6BeGI8FNbergimXGmQchGeW8";
  
    }
    const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
      const cookieString = document.cookie; // Get all cookies as a string
      console.log(cookieString)
      const cookies = cookieString.split(";"); // Split into individual cookies
     
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim(); // Remove leading spaces
        if (cookie.startsWith(name + "=")) {
          if(cookie.substring(name.length + 1)===""){
            window.location.href =accountsUrl;
          }
          return cookie.substring(name.length + 1); // Return the value of the cookie
        }
      }
      window.location.href =accountsUrl;
      return null; // Return null if the cookie is not found    
        }